import QuestionMark from "./QuestionMark.svg";

export default function MissingRegionInfoFiller({
  nodeId,
  padding,
}){

  let qmSvg=<img style={{ 
    pointerEvents:'none',
    width:'70%', }} src={QuestionMark}/>
  let qmDiv= <div style={{
    pointerEvents:'none',
    fontSize:36}}>?</div>

  return (

    <div 
        nodeId={nodeId}
        className={"no-region-specified sg-row flex-expand v-center h-center"} style={{
          position:'relative',
          top:0,
          left:0,
          padding,
          width:'100%',//parentBox.width, 
          height:'100%',//parentBox.height,
          fontSize:10,
          //color:'#aaa',
          color:'black',
          background:'pink',
          pointerEvents:'auto',
        }}>
          {qmSvg}
      </div>
  )
}
